/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PublicKeyAuthenticator } from './PublicKeyAuthenticator';
import {
    PublicKeyAuthenticatorFromJSON,
    PublicKeyAuthenticatorFromJSONTyped,
    PublicKeyAuthenticatorToJSON,
} from './PublicKeyAuthenticator';

/**
 * 
 * @export
 * @interface PublicKeyCredentialParams
 */
export interface PublicKeyCredentialParams {
    /**
     * The ID of the webauthn credential
     * @type {string}
     * @memberof PublicKeyCredentialParams
     */
    webauthn_credential_id: string;
    /**
     * Base64-encoded public key
     * @type {string}
     * @memberof PublicKeyCredentialParams
     */
    public_key: string;
    /**
     * The attestation type for the public key (defaults to "none")
     * @type {string}
     * @memberof PublicKeyCredentialParams
     */
    attestation_type: string;
    /**
     * 
     * @type {PublicKeyAuthenticator}
     * @memberof PublicKeyCredentialParams
     */
    authenticator: PublicKeyAuthenticator;
}

/**
 * Check if a given object implements the PublicKeyCredentialParams interface.
 */
export function instanceOfPublicKeyCredentialParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "webauthn_credential_id" in value;
    isInstance = isInstance && "public_key" in value;
    isInstance = isInstance && "attestation_type" in value;
    isInstance = isInstance && "authenticator" in value;

    return isInstance;
}

export function PublicKeyCredentialParamsFromJSON(json: any): PublicKeyCredentialParams {
    return PublicKeyCredentialParamsFromJSONTyped(json, false);
}

export function PublicKeyCredentialParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicKeyCredentialParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'webauthn_credential_id': json['webauthn_credential_id'],
        'public_key': json['public_key'],
        'attestation_type': json['attestation_type'],
        'authenticator': PublicKeyAuthenticatorFromJSON(json['authenticator']),
    };
}

export function PublicKeyCredentialParamsToJSON(value?: PublicKeyCredentialParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'webauthn_credential_id': value.webauthn_credential_id,
        'public_key': value.public_key,
        'attestation_type': value.attestation_type,
        'authenticator': PublicKeyAuthenticatorToJSON(value.authenticator),
    };
}

